// Merkezi hata loglama yardımcısı (CWE-209: hassas bilgi içeren hata mesajı).
//
// Geliştirmede (dev/test) hata nesnesi tam detayla console'a yazılır — debugging korunur.
// Production'da hata nesnesi (stack trace / API response gövdesi / iç path'ler) console'a
// SIZDIRILMAZ; yalnız geliştirici tarafından yazılmış string bağlam (örn. 'Özet hatası:')
// korunur, yoksa jenerik bir mesaj yazılır.
//
// Kullanım: `console.error(e)` yerine `logError(e)`,
//           `console.error('Özet hatası:', e)` yerine `logError('Özet hatası:', e)`.
export function logError(...args) {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-restricted-properties
    console.error(...args);
    return;
  }
  const ctx = args.find((a) => typeof a === 'string');
  // eslint-disable-next-line no-restricted-properties
  console.error(ctx || 'Bir hata oluştu.');
}

export default logError;
